import { CheckCircle2 } from "lucide-react";
import { Reveal, Overline } from "../Reveal";
import { WHY } from "../../data/content";

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="relative py-16 md:py-24 overflow-hidden bg-gk-panel/30">
      <div className="ambient-emerald" style={{ width: 480, height: 480, bottom: "-10%", left: "-10%", opacity: 0.25 }} />

      <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <Reveal>
            <Overline>Why Choose Us</Overline>
            <h2 className="font-cinzel text-2xl sm:text-3xl font-semibold text-white mt-4 leading-tight">
              Reasons to <span className="text-gold-metallic">trust us.</span>
            </h2>
            <p className="font-poppins text-white/55 mt-4 text-sm leading-relaxed">
              We don't just deliver projects — we build enduring partnerships engineered around your success.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-white/10 border-t border-white/10">
            {WHY.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.05}>
                <div
                  data-testid={`why-item-${i}`}
                  data-cursor="hover"
                  className="group flex items-start gap-5 py-5 px-2 hover:px-6 transition-all duration-500 hover:bg-white/[0.02] rounded-xl"
                >
                  <span className="font-cinzel text-base text-gk-gold/50 group-hover:text-gk-gold transition-colors pt-1 w-8">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <CheckCircle2 className="text-gk-champagne shrink-0 mt-0.5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-500" size={20} strokeWidth={1.4} />
                  <div className="flex-1">
                    <h3 className="font-cinzel text-xl text-white group-hover:text-gk-champagne transition-colors">{w.title}</h3>
                    <p className="font-poppins text-sm text-white/50 mt-1.5 leading-relaxed max-h-0 overflow-hidden opacity-0 group-hover:max-h-24 group-hover:opacity-100 transition-all duration-500">
                      {w.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
